import { DEMAND_TYPES } from "@core/constants";
import { IRecruitment } from "./recruitment.interface";
import { RecruitmentPermanentAdapter } from "./recruitment-permanent.adapter";
import { RecruitmentAEAdapter } from "./recruitment-ae.adapter";
import { RecruitmentDefaultModel } from "./recruitment-default.model";
import { RecruitmentBookingExpressAdapter } from "./recruitment-booking-express-adapter";

export class RecruitmentFactory {
  constructor(data = {}) {
    const demandType = data[IRecruitment.demandType];
    switch (demandType) {
      case DEMAND_TYPES.AE:
        if (!data[IRecruitment.isBookingExpress]) {
          return new RecruitmentAEAdapter(data);
        }
        return new RecruitmentBookingExpressAdapter(data);
      case DEMAND_TYPES.CDI:
      case DEMAND_TYPES.SEASON:
        return new RecruitmentPermanentAdapter(data);
      default:
        return new RecruitmentDefaultModel(data);
    }
  }
}
